import { render, staticRenderFns } from "./SidebarOpener.vue?vue&type=template&id=cb7ebf12&"
import script from "./SidebarOpener.vue?vue&type=script&lang=js&"
export * from "./SidebarOpener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports